import HTTP from '../HTTP';

export default {
  index() {
    return HTTP.get('/sector-application');
  },
  save(data) {
    return HTTP.post('/sector-application', data);
  },
  delete(id) {
    return HTTP.delete(`/sector-application/${id}`);
  },
};
